import Select from 'react-select'
import { components } from 'react-select'
import '../../styles/react-select/_react-select.css'
import { FiChevronDown } from 'react-icons/fi'
function AutocompleteCustom({
  options,
  value,
  onChange,
  onInputChange,
  disabled = false,
  placeholder = '',
  isClearable = false,
  height = '40px',
  isLoading = false
}) {
  const CustomDropdownIndicator = (props) => {
    const { menuIsOpen } = props.selectProps
    return (
      <components.DropdownIndicator {...props}>
        <FiChevronDown
          size={22}
          color="var(--color-on-base-content-high)"
          style={{
            transition: 'transform 0.2s ease',
            transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        />
      </components.DropdownIndicator>
    )
  }
  return (
    <Select
      isLoading={isLoading}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: height,
          maxHeight: height,
          height,
          borderRadius: '8px',
          borderColor: state.isDisabled ? '#dee2e6' : '#dee2e6',
          background: state.isDisabled ? '#F9FAFB' : baseStyles.backgroundColor,
          cursor: state.isDisabled ? 'not-allowed' : 'default',
          boxShadow: 'none',
          '&:hover': {
            borderColor: state.isDisabled ? '#dee2e6' : '#dee2e6'
          }
        }),

        menu: (provided) => ({
          ...provided,
          zIndex: 9999
        }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 9999
        }),

        singleValue: (provided, state) => ({
          ...provided,
          color: state.isDisabled ? '#6c757d' : provided.color
        }),

        placeholder: (provided, state) => ({
          ...provided,
          paddingBottom: '5px',
          fontSize: 6,
          fontWeight: 400,
          color: state.isDisabled ? '#6c757d' : '#adb5bd'
        }),

        valueContainer: (provided) => ({
          ...provided,
          minHeight: height,
          maxHeight: height,
          padding: '0px 0px 0px 6px',
          fontSize: 14,
          text: 'red'
        }),

        clearIndicator: (provided) => ({
          ...provided,
          padding: '6px'
        }),

        dropdownIndicator: (provided, state) => ({
          ...provided,
          padding: '6px',
          color: state.isDisabled ? '#6c757d' : provided.color
        })
      }}
      components={{
        DropdownIndicator: CustomDropdownIndicator
      }}
      menuPortalTarget={document.body}
      menuPlacement="auto"
      menuPosition="fixed"
      isClearable={isClearable}
      isDisabled={disabled}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      className="basic-single"
      classNamePrefix="select"
    />
  )
}

export default AutocompleteCustom
